import { useCallback } from 'react';

import { MutationResult } from '@apollo/react-common';
import { useMutation } from '@apollo/react-hooks';
import { ExecutionResult } from 'graphql';

import {
  FitnessApplicationSettingsInput,
  SaveFitnessApplicationSettingsMutation,
  SaveFitnessApplicationSettingsMutationVariables,
} from '../../../types/__generated__';
import { PageMetaContext } from '../../context/PageMetaContext';
import { useNotNullableContext } from '../useNotNullableContext';
import STRAVA_SETTINGS from './useStravaSettings.gql';

export default function useStravaSettings(
  FRAGMENT: any,
): [
  (
    input: FitnessApplicationSettingsInput,
    shouldRefetchQuery?: boolean,
  ) => Promise<ExecutionResult<SaveFitnessApplicationSettingsMutation>>,
  MutationResult<SaveFitnessApplicationSettingsMutation>,
] {
  const [saveStravaSettings, mutationResult] = useMutation<
    SaveFitnessApplicationSettingsMutation,
    SaveFitnessApplicationSettingsMutationVariables
  >(STRAVA_SETTINGS, {
    context: {
      credentials: 'include',
    },
  });
  const { pageType, pageShortName, isPreview } = useNotNullableContext(
    PageMetaContext,
  );

  return [
    useCallback(
      (input, shouldRefetchQuery) =>
        saveStravaSettings({
          variables: {
            input,
          },
          refetchQueries: shouldRefetchQuery
            ? [
                {
                  query: FRAGMENT,
                  variables: {
                    type: pageType.toUpperCase(),
                    slug: pageShortName,
                    preview: isPreview,
                  },
                  context: {
                    credentials: 'include',
                  },
                },
              ]
            : undefined,
        }),
      [FRAGMENT, isPreview, pageShortName, pageType, saveStravaSettings],
    ),
    mutationResult,
  ];
}
